import { __assign, __rest } from 'tslib';

// borrowed from  https://github.com/seek-oss/braid-design-system/blob/2ba61622cc3ec9bfb1ec2082002171ddfeddc143/packages/braid-design-system/lib/components/private/smoothScroll.ts
var easeModifier = function (t) {
    return t > 0.5 ? 4 * Math.pow(t - 1, 3) + 1 : 4 * Math.pow(t, 3);
};
var getExpectedTime = function (distance, duration, speed, minDuration) {
    var calculatedDuration = distance / speed;
    var normalizedDuration = minDuration > calculatedDuration ? minDuration : calculatedDuration;
    return duration !== null ? duration : normalizedDuration;
};
var getScrollPosition = function (scrollContainer, direction) { return scrollContainer[direction === "horizontal" ? "scrollLeft" : "scrollTop"]; };
var getScrollOffset = function (scrollContainer, targetElement, direction) {
    if (scrollContainer === window.document.documentElement) {
        var scrollPosition = getScrollPosition(scrollContainer, direction);
        var positionOnScreen = targetElement.getBoundingClientRect()[direction === "horizontal" ? "left" : "top"];
        return positionOnScreen + scrollPosition;
    }
    var totalOffset = 0;
    var currentElement = targetElement;
    var offsetKey = direction === "horizontal" ? "offsetLeft" : "offsetTop";
    while (scrollContainer.contains(currentElement) ||
        currentElement === scrollContainer) {
        totalOffset += currentElement[offsetKey];
        var offsetParent = currentElement.offsetParent;
        if (!(offsetParent instanceof HTMLElement)) {
            break;
        }
        currentElement = offsetParent;
    }
    return totalOffset;
};
var scrollTo = function (scrollContainer, direction, to) {
    scrollContainer[direction === "horizontal" ? "scrollLeft" : "scrollTop"] = to;
};
var getPossibleScroll = function (scrollContainer, direction) {
    return scrollContainer[direction === "horizontal" ? "scrollWidth" : "scrollHeight"] -
        (scrollContainer === window.document.documentElement
            ? 0
            : scrollContainer[direction === "horizontal" ? "offsetWidth" : "offsetHeight"]);
};
var limitNumberToRange = function (number, min, max) {
    if (number < min) {
        return min;
    }
    if (number > max) {
        return max;
    }
    return number;
};
var scroll = function (scrollContainer, direction, to, _a, callback) {
    var _b = _a.duration, duration = _b === void 0 ? null : _b, _c = _a.speed, speed = _c === void 0 ? 2 : _c, _d = _a.minDuration, minDuration = _d === void 0 ? 0 : _d;
    var startTime = Date.now();
    var initial = getScrollPosition(scrollContainer, direction);
    var possibleScroll = getPossibleScroll(scrollContainer, direction);
    var targetScrollPosition = limitNumberToRange(to, 0, possibleScroll);
    var total = Math.abs(targetScrollPosition - initial);
    var expectedTime = getExpectedTime(total, duration, speed, minDuration);
    var scrollForwards = targetScrollPosition > initial;
    var step = function () {
        requestAnimationFrame(function () {
            var timePassed = Date.now() - startTime;
            var progress = timePassed / expectedTime;
            var distance = easeModifier(progress) * total;
            var newPosition = Math.floor(scrollForwards ? initial + distance : initial - distance);
            var isComplete = scrollForwards
                ? newPosition >= targetScrollPosition
                : newPosition <= targetScrollPosition;
            if (isComplete) {
                scrollTo(scrollContainer, direction, targetScrollPosition);
                if (callback) {
                    callback();
                }
            }
            else {
                scrollTo(scrollContainer, direction, newPosition);
                step();
            }
        });
    };
    if (targetScrollPosition !== initial) {
        step();
    }
    else if (callback) {
        callback();
    }
};
var smoothScroll = function (element, _a) {
    if (_a === void 0) { _a = {}; }
    var _b = _a.scrollContainer, scrollContainer = _b === void 0 ? window.document.documentElement : _b, _c = _a.direction, direction = _c === void 0 ? "vertical" : _c, _d = _a.offset, offset = _d === void 0 ? 0 : _d, _e = _a.position, position = _e === void 0 ? "start" : _e, scrollOptions = __rest(_a, ["scrollContainer", "direction", "offset", "position"]);
    return new Promise(function (resolve) {
        var scrollOffset = getScrollOffset(scrollContainer, element, direction);
        var scrollPosition = position === "end"
            ? scrollOffset -
                scrollContainer.offsetWidth +
                element.offsetWidth +
                offset
            : scrollOffset - offset;
        scroll(scrollContainer, direction, scrollPosition, scrollOptions, resolve);
    });
};
var smoothScrollIntoView = function (element, options) {
    var _a = options.scrollContainer, scrollContainer = _a === void 0 ? window.document.documentElement : _a, _b = options.direction, direction = _b === void 0 ? "vertical" : _b, _c = options.offset, offset = _c === void 0 ? 0 : _c;
    var containerWidth = scrollContainer.offsetWidth;
    var scrollOffset = getScrollOffset(scrollContainer, element, direction);
    var positionOnScreen = scrollOffset - getScrollPosition(scrollContainer, direction);
    if (positionOnScreen < offset) {
        smoothScroll(element, __assign(__assign({}, options), { position: "start" }));
    }
    else if (positionOnScreen > containerWidth - element.offsetWidth - offset) {
        smoothScroll(element, __assign(__assign({}, options), { position: "end" }));
    }
};

export { smoothScroll, smoothScrollIntoView };
//# sourceMappingURL=smoothScroll.js.map
